import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getAlmostSoldOutTooltipText } from '../utils/utils';

const ProductAvailabilityNote = ({ kind, quantity, productId }) => {
  if (kind === 'on-demand') {
    return <div className='mt-1' style={{ fontSize: 14 }}>
      <div className='text-primary' style={{ fontWeight: 600 }}>
        <span style={{ whiteSpace: 'nowrap' }}>
          Під замовлення
          <OverlayTrigger placement='top' overlay={
            <Tooltip id={`availability-on-demand-${productId}`}>
              <strong>Товару немає в наявності. Його буде замовлено у постачальника.</strong>
            </Tooltip>
          }>
            <i className='bi bi-info-circle px-1' tabIndex={0} aria-label='Інформація про товар під замовлення' />
          </OverlayTrigger>
        </span>
      </div>
    </div>;
  }

  const label = quantity === 1 ? 'Залишилась лише' : 'Залишилось лише';
  const explanation = getAlmostSoldOutTooltipText(quantity);

  return <OverlayTrigger placement='top' overlay={
    <Tooltip id={`availability-${kind}-${productId}`}>{explanation}</Tooltip>
  }>
    <span className={`product-availability-note product-availability-note--${kind}`} tabIndex={0}>
      <i className='bi bi-box-seam' aria-hidden='true' />
      <span>{label} <strong>{quantity} шт.</strong></span>
    </span>
  </OverlayTrigger>;
};

export default ProductAvailabilityNote;
